import React from "react";
import RadioBox from "../FormComponents/RadioBox";
import { TextField, FormHelperText } from "@material-ui/core";
import { getIn } from "formik";
import CheckBoxComponent from "../FormComponents/CheckBox";
import { Number } from "../../utils/Number";
import { TextMaskCustom } from "../../utils/TextMaskCustom";
import AutoCompleteStates from "../FormComponents/AutoCompleteStates";

const otherInfo = [
  {
    label: "How did the accident occur?",
    name: "accident.description",
    type: "textArea",
    required: true,
  },
  {
    label: "Who is responsible for the accident?",
    name: "accident.responsibility",
    type: "text",
    required: true,
  },
];
const otherAccidentInfo = [
  {
    label: "Responsible Party's Name",
    name: "accident.responsiblePersonName",
    type: "text",
    required: true,
  },
  {
    label: "Address",
    name: "accident.addressLine1",
    type: "text",
    required: true,
  },
  { label: "City", name: "accident.city", type: "text", required: true },
  { label: "State", name: "accident.state", type: "autoComplete", required: true },
  { label: "ZIP Code", name: "accident.zipCode", type: "number", required: true },
  { label: "Phone", name: "accident.phone", type: "phone", required: true },
];
const insuredInfo = [
  {
    label: "Claim Number",
    name: "accident.claimNo",
    type: "text",
  },
  {
    label: "Insurance Name",
    name: "accident.insurerName",
    type: "text",
  },

  {
    label: "Address",
    name: "accident.insurerAddressLine1",
    type: "text",
  },
  { label: "City", name: "accident.insurerCity", type: "text" },
  { label: "State", name: "accident.insurerState", type: "autoComplete" },
  { label: "ZIP Code", name: "accident.insurerZipCode", type: "number" },
  { label: "Phone", name: "accident.insurerPhone", type: "phone" },
];

const OtherAccidentInfo = ({ values, touched, error, handleChange, errors, setFieldValue }) => {
  return (
    <div className="card custom-card">
      <div className="form-group">
        <h5>OTHER ACCIDENT INFORMATION</h5>
      </div>
      <div>
        <div className="row  align-items-top">
          <div className="col-md-12 col-lg-auto col-xl-auto text-overlaping other-info-alignment">
            <p>
              Where did the accident occur?{" "}
              {getIn(touched, "accident.location") && getIn(errors, "accident.location") ? (
                <span style={{ color: "#f44336" }}>*</span>
              ) : (
                "*"
              )}
            </p>
          </div>

          <div className="form-group col-md-12 col-lg-auto col-xl-auto custom-legend">
            <CheckBoxComponent
              name="accident.location"
              checkBoxType="multi"
              label={["Own Home", "Another Home", "Business", "Public Place"]}
              handleChange={handleChange}
              error={Boolean(getIn(touched, "accident.location") && getIn(errors, "accident.location"))}
              helperText={
                getIn(touched, "accident.location") &&
                getIn(errors, "accident.location") &&
                getIn(errors, "accident.location")
              }
            />
            <FormHelperText style={{ marginTop: "-20px" }}>
              {getIn(touched, "accident.location") && getIn(errors, "accident.location") && (
                <span style={{ color: "#f44336" }}>Please select at least one location</span>
              )}
            </FormHelperText>
          </div>
        </div>
        <div>
          <div className="row ">
            {otherInfo.map(({ label, name, type, required = false }, ind) => {
              if (type === "text") {
                return (
                  <div
                    className="form-group col-md-12 col-lg-12 col-12 other-text-break text-space"
                    key={ind}
                  >
                    <TextField
                      label={label}
                      name={name}
                      onChange={handleChange}
                      value={values[name]}
                      fullWidth
                      aria-label="text-field"
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required={required}
                      inputProps={{ maxLength: 150 }}
                      // margin="dense"
                    ></TextField>
                  </div>
                );
              } else if (type === "textArea") {
                return (
                  <div className="form-group col-md-12 col-lg-12 col-12 " key={ind}>
                    <TextField
                      label={label}
                      name={name}
                      onChange={handleChange}
                      value={values[name]}
                      multiline
                      rows={2}
                      fullWidth
                      aria-label="text-field"
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required={required}
                      inputProps={{ maxLength: 995 }}
                      // margin="dense"
                    ></TextField>
                  </div>
                );
              }
            })}
          </div>

          <div className="row  mt-2 align-items-top">
            <div className="col-lg-8 col-xl-6 col-md-12 radio-btn-alignment">
              <p>
                {" "}
                Has the accident been reported to the responsible party?{" "}
                {getIn(errors, "accident.reportedToResponsiblePerson") &&
                getIn(touched, "accident.reportedToResponsiblePerson") ? (
                  <span style={{ color: "#f44336" }}>*</span>
                ) : (
                  "*"
                )}
              </p>
            </div>
            {/* 
              {console.log(getIn(errors))} */}
            <div className="col-lg-4 col-xl-6 col-md-12 custom-legend">
              <RadioBox
                name="accident.reportedToResponsiblePerson"
                value={values.accident.reportedToResponsiblePerson}
                label={["Yes", "No"]}
                handleChange={handleChange}
                helperText={
                  getIn(touched, "accident.reportedToResponsiblePerson") &&
                  getIn(errors, "accident.reportedToResponsiblePerson") &&
                  getIn(errors, "accident.reportedToResponsiblePerson")
                }
              />
            </div>
          </div>

          <div className="row  mt-2 w-100">
            {otherAccidentInfo.map(({ label, name, type, required = false }, ind) => {
              if (type === "text") {
                return (
                  <div className="form-group col-md-6 col-lg-4" key={ind}>
                    <TextField
                      label={label}
                      name={name}
                      onChange={handleChange}
                      value={values[name]}
                      fullWidth
                      aria-label="text-field"
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: name === "accident.city" ? 35 : 50 }}
                      required={values.accident.reportedToResponsiblePerson === "Yes" ? required : false}
                      // margin="dense"
                    ></TextField>
                  </div>
                );
              } else if (type === "number" || type === "phone") {
                return (
                  <div className="form-group col-md-6 col-lg-4" key={ind}>
                    <TextField
                      label={label}
                      name={name}
                      onChange={handleChange}
                      value={values[name]}
                      fullWidth
                      aria-label="text-field"
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: type === "phone" ? TextMaskCustom : Number,
                      }}
                      inputProps={{ maxLength: type === "number" ? 5 : undefined }}
                      required={values.accident.reportedToResponsiblePerson === "Yes" ? required : false}
                      // margin="dense"
                    ></TextField>
                  </div>
                );
              } else if (type === "autoComplete") {
                return (
                  <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                    <AutoCompleteStates
                      label={label}
                      name={name}
                      onChange={(e, value) => {
                        if (value) {
                          setFieldValue(`${name}`, value.code);
                        } else {
                          setFieldValue(`${name}`, "");
                        }
                      }}
                      value={values[name]}
                      aria-label="auto-complete"
                      fullWidth
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      required={values.accident.reportedToResponsiblePerson === "Yes" ? true : false}
                    />
                  </div>
                );
              }
            })}
          </div>

          <div className="row  mt-2 align-items-top">
            <div className="col-lg-8 col-xl-7 col-md-12 radio-btn-alignment">
              <p>
                Has a claim been opened with responsible party's insurance?{" "}
                {getIn(errors, "accident.isClaimRaised") && getIn(touched, "accident.isClaimRaised") ? (
                  <span style={{ color: "#f44336" }}>*</span>
                ) : (
                  "*"
                )}
              </p>
            </div>
            <div className="col-lg-4 col-xl-5 col-md-12 custom-legend">
              <RadioBox
                name="accident.isClaimRaised"
                value={values.accident.isClaimRaised}
                label={["Yes", "No"]}
                handleChange={handleChange}
                helperText={
                  getIn(touched, "accident.isClaimRaised") &&
                  getIn(errors, "accident.isClaimRaised") &&
                  getIn(errors, "accident.isClaimRaised")
                }
              />
            </div>
          </div>

          <div className="row  mt-2 w-100">
            {insuredInfo.map(({ label, name, type }, ind) => {
              if (type === "text") {
                return (
                  <div className="form-group col-md-6 col-lg-4" key={ind}>
                    <TextField
                      label={label}
                      name={name}
                      fullWidth
                      onChange={handleChange}
                      value={values[name]}
                      aria-label="text-field"
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{
                        maxLength:
                          name === "accident.insurerCity" || name === "accident.claimNo" ? 35 : 50,
                      }}
                      // margin="dense"
                    ></TextField>
                  </div>
                );
              } else if (type === "number" || type === "phone") {
                return (
                  <div className="form-group col-md-6 col-lg-4" key={ind}>
                    <TextField
                      label={label}
                      name={name}
                      fullWidth
                      onChange={handleChange}
                      value={values[name]}
                      aria-label="text-field"
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        inputComponent: type === "phone" ? TextMaskCustom : Number,
                      }}
                      inputProps={{ maxLength: type === "number" ? 5 : undefined }}
                      // margin="dense"
                    ></TextField>
                  </div>
                );
              } else if (type === "autoComplete") {
                return (
                  <div className="form-group col-md-6 col-lg-4" key={name + ind}>
                    <AutoCompleteStates
                      label={label}
                      name={name}
                      onChange={(e, value) => {
                        if (value) {
                          setFieldValue(`${name}`, value.code);
                        } else {
                          setFieldValue(`${name}`, "");
                        }
                      }}
                      value={values[name]}
                      aria-label="auto-complete"
                      fullWidth
                      error={Boolean(getIn(touched, name) && getIn(errors, name))}
                      helperText={getIn(touched, name) && getIn(errors, name) && getIn(errors, name)}
                    />
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherAccidentInfo;
